import { environment } from '../../environments/environment';

export class SETTINGS {
  public static ACCESS_TOKEN = '%&^%^*@&*#';
  public static REFRESH_TOKEN = '&@&#&$(@&##';
  public static LOGGED_IN_USER = '#$%@^^%';
  public static LOGGED_IN_USER_ID = '#$%@^^%^%#$^&';
  /** Frontend-only: AES-encrypted role name (ADMIN, SUPERVISOR, STAFF) for access control. */
  public static USER_ROLE = 'USER_ROLE_ACAN';
  // public static PREVIOUS_PAGE = '#$%@^^%$%&^^%^%#$^&';
  // public static PREVIOUS_PAGE_ID = '#$%@^^%$%&^^%^^%#$^^&';
  // public static SINGLE_JOB_ID = '#$%@^^%$%&&*^%^^%^%#$^&';
  public static COMPANY = '^&&^$^^(*&)*';
  public static COMPANY_NAME = '^&&^$^^()&*&%*&)*';
  // public static IS_DIRTY = '(^&^$^)(&%*&)';

  public static BASE_API = environment.baseURL; //do not change this

  public static KEYS = {
    SECRET: 'iIUsWtNZcf',
    GOOGLE_API_KEY: 'AIzaSyAJmt5N34DIItO1Avyk5FdF__nTuhzQc2A',
  };

  public static REGEX = {
    PASSWORD: {
      EXP: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$',
    },
    PHONE: {
      EXP: /^(?:\+61|0)4\d{8}$|^(?:\+94|0)7\d{8}$/,
    },
    COUNTRY_CODE_PHONE: {
      EXP: '^(\\+\\d{1,3}\\s?)?\\d{1,10}$',
    },
  };

  public static PRIORITY_LEVEL = [
    { label: 'Low', value: 'LOW' },
    { label: 'Medium', value: 'MEDIUM' },
    { label: 'High', value: 'HIGH' },
  ];

  public static QUOTATION_STATUSES = [
    {
      label: 'New Lead',
      styleColor: 'quotation-new-quote',
      value: 'NEW_QUOTE',
    },
    {
      label: 'Lead Lost',
      styleColor: 'quotation-estimating',
      value: 'ESTIMATING',
    },
    {
      label: 'New Quote',
      styleColor: 'quotation-Ready-for-pricing',
      value: 'READY_TO_PRICING',
    },
    {
      label: 'Site Inspection',
      styleColor: 'quotation-ready-to-send',
      value: 'READY_TO_SEND',
    },
    { label: 'Quote Sent', styleColor: 'quotation-sent', value: 'SENT' },
    {
      label: 'Negotiation',
      styleColor: 'quotation-revision',
      value: 'REVISION',
    },
    { label: 'Won', styleColor: 'quotation-approved', value: 'APPROVED' },
    { label: 'Lost', styleColor: 'quotation-rejected', value: 'REJECTED' },
    { label: 'Hold', styleColor: 'quotation-hold', value: 'HOLD' },
  ];

  public static INVOICE_STATUSES = [
    { label: 'Draft', styleColor: 'invoice-draft', value: 'DRAFT' },
    { label: 'Sent', styleColor: 'invoice-sent', value: 'SENT' },
    { label: 'Unpaid', styleColor: 'invoice-unpaid', value: 'UNPAID' },
    { label: 'Paid', styleColor: 'invoice-paid', value: 'PAID' },
    { label: 'Overdue', styleColor: 'invoice-overdue', value: 'OVERDUE' },
    {
      label: 'Partial Payment Made',
      styleColor: 'invoice-partial',
      value: 'PARTIAL_PAYMENT_MADE',
    },
    { label: 'Cancelled', styleColor: 'invoice-cancelled', value: 'CANCELLED' },
    { label: 'On Hold', styleColor: 'invoice-on-hold', value: 'ON_HOLD' },
  ];
  public static COMMON_WORDS = {
    MAIN: 'Main',
    BILLING: 'Billing',
  };

  public static BILLING_INVOICE_STATUS = {
    DRAFT: "DRAFT", APPROVED: "APPROVED", DOWNLOADED: "DOWNLOADED", SENT: "SENT", PAID: "PAID", OVERDUE: "OVERDUE",
  };
  public static JOB_BILLING_INVOICE_STATUS = {
    DRAFT: "DRAFT",
    RECONCILED: "RECONCILED",
    APPROVED: "APPROVED",
    DOWNLOADED: "DOWNLOADED",
    SENT: "SENT",
    PAID: "PAID",
    OVERDUE: "OVERDUE",
  };
  public static INITIAL_SKELETON_DATA = [1, 2, 3, 4, 5];

  public static daysInWeek = [
    { label: 'Monday', value: 'MO' },
    { label: 'Tuesday', value: 'TU' },
    { label: 'Wednesday', value: 'WE' },
    { label: 'Thursday', value: 'TH' },
    { label: 'Friday', value: 'FR' },
    { label: 'Saturday', value: 'SA' },
    { label: 'Sunday', value: 'SU' }
  ]

  public static RATE_OPTIONS = [
    { label: 'Day Rate', value: 0 },
    { label: 'Night Rate', value: 1 }
  ]

  public static GST_OPTIONS = [
    { name: 'GST Excluded', value: true },
    { name: 'GST Included', value: false },
  ];

  public static VERSION = '2.0.0'

  /** Currency code for job/time-clock amounts and pay rates (e.g. job-approvals, time-clock). */
  public static CURRENCY_CODE = 'AUD';

  /** Safe query tokens for back navigation (no # — avoids URL fragment breakage). */
  public static NAV_PREV_PAGE = {
    JOB_TABLE: 'job_table',
    JOB_KANBAN: 'job_kanban',
    JOB_SINGLE_EDIT: 'job_single_edit',
  } as const;
}
